import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { ApiService } from '../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/services/common.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: "./changepassword.component.html",
  styleUrl: "./changepassword.component.css"
})
export class ChangepasswordComponent implements OnInit {
  email = sessionStorage.getItem('email');
  userType: any;

  IndustryAssociationUserId: any;
  IAUserName: any;

  userType_session: any;
  MsMeUserId: any;
  MsMeUserName: any;

  MSSIDCUserId: any;
  MSSIDCUserName: any;

  DICUserId: any;
  DICUserName: any;

  OldPassword: any;
  NewPassword: any;
  ConfirmPassword: any;

  showNewPassword: boolean = false;
  showConfirmNewPassword: boolean = false;


  readonlyUsername: any = sessionStorage.getItem('userName')?.replace(/"/g, '') || '';

  constructor(private router: Router,
    private fb: FormBuilder,
    //private passwordService: PasswordService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private common: CommonService,
    private cdr: ChangeDetectorRef
  ) { }


  form1 = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]),
    oldpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]),
    newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
    confirmnewpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),

  });


  ngOnInit(): void {
    var userType_session = this.readonlyUsername.replace(/"/g, '') || '';; //= sessionStorage.getItem('readonlyUsername')?.replace(/"/g, '') || '';
    this.form1.controls['username'].setValue(userType_session)
    this.userType = sessionStorage.getItem('singInAs');
    this.loadUserData();
    this.initializeForm();    
  }

  initializeForm() {
    if (this.userType == 'IAUser') {
      const usernameControl = new FormControl({ value: this.readonlyUsername, disabled: true });
      this.form1 = this.fb.group({
        iauserid: new FormControl(''),
        username: usernameControl,
        oldpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]),
        newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
        confirmnewpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
      }, {
        validator: this.passwordMatchValidator
      });
    }
    else if (this.userType == 'MsMeUser') {
      const usernameControl = new FormControl({ value: this.readonlyUsername, disabled: true });
      this.form1 = this.fb.group({
        msmeuserid: new FormControl(''),
        username: usernameControl,
        oldpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]),
        newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
        confirmnewpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
      }, {
        validator: this.passwordMatchValidator
      });
    }
    else if (this.userType == 'MSSIDCUser')
    {
        const usernameControl = new FormControl({ value: this.readonlyUsername, disabled: true });
        this.form1 = this.fb.group({
          mssidcuserid: new FormControl(''),
          username: usernameControl,
          oldpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]),
          newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
          confirmnewpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
        }, {
          validator: this.passwordMatchValidator
        });
    }
    else if (this.userType == 'DICUser') {
      const usernameControl = new FormControl({ value: this.readonlyUsername, disabled: true });
      this.form1 = this.fb.group({
        dicuserid: new FormControl(''),
        username: usernameControl,
        oldpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]),
        newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
        confirmnewpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(this.common.passwordPattern)]),
      }, {
        validator: this.passwordMatchValidator
      });
    }
  }

  loadUserData() {
    if (this.userType == 'IAUser') {
      this.IndustryAssociationUserId = sessionStorage.getItem('industryAssociationUserId');
      this.IAUserName = sessionStorage.getItem('iaUserName')?.replace(/"/g, '') || '';
      this.readonlyUsername = this.IAUserName;
      this.IndustryAssociationUserId = this.IndustryAssociationUserId;
    }
    else if (this.userType == 'MsMeUser') {
      this.MsMeUserId = sessionStorage.getItem('msMeUserId');
      this.MsMeUserName = sessionStorage.getItem('msMeUserName')?.replace(/"/g, '') || '';
      this.readonlyUsername = this.MsMeUserName;
      this.MsMeUserId = this.MsMeUserId;
    }
    else if (this.userType == 'MSSIDCUser') {
      this.MSSIDCUserId = sessionStorage.getItem('mssidcuserid');
      this.MSSIDCUserName = sessionStorage.getItem('name')?.replace(/"/g, '') || '';
      this.readonlyUsername = this.MSSIDCUserName;
      this.MSSIDCUserId = this.MSSIDCUserId;
    }
    else if (this.userType == 'DICUser') {
      this.DICUserId = sessionStorage.getItem('dicUserId');
      this.DICUserName = sessionStorage.getItem('name')?.replace(/"/g, '') || '';
      this.readonlyUsername = this.DICUserName;
      this.DICUserId = this.DICUserId;
    }
    else {
    }
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const { newpassword, confirmnewpassword } = formGroup.controls;

    // Trim spaces and ensure both values are strings
    const newPasswordValue = newpassword.value ? newpassword.value.trim() : '';
    const confirmNewPasswordValue = confirmnewpassword.value ? confirmnewpassword.value.trim() : '';

    if (newPasswordValue !== confirmNewPasswordValue) {
      confirmnewpassword.setErrors({ passwordMismatch: true });
    } else {
      confirmnewpassword.setErrors(null);
    }

  }

  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleShowConfirmNewPassword() {
    this.showConfirmNewPassword = !this.showConfirmNewPassword;
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
    alert('Pasting is disabled in the Confirm Password field for security reasons.');
  }
  get f() {
    return this.form1.controls;
  }

  //public onReset() {
  //  //
  //  this.form1.patchValue({
  //    oldpassword: '',
  //    newpassword: '',
  //    confirmnewpassword: ''
  //  });

  //}

  public onReset() {
    this.form1.patchValue({
      newpassword: '',
      confirmnewpassword: ''
    });
  }


  //onCancel() {
  //  if (this.userType == 'IAUser') {
  //    window.history.back();
  //  }
  //  else if (this.userType == 'MsMeUser') {
  //    window.history.back();
  //  }
  //}

  onCancel() {
    if (this.userType === 'IAUser') {
      this.router.navigate(['/iauserdashboard']);
    } else if (this.userType === 'MsMeUser') {
      this.router.navigate(['/msmeuserdashboard']);
    } else if (this.userType === 'MSSIDCUser') {
      this.router.navigate(['/mssidcdashboard']);
    }
    else {
      this.router.navigate(['/login']); // Default fallback
    }
  }

  onSubmit() {
    if (this.userType == 'IAUser') {
      if (this.form1.valid) {
        const formData = this.form1.value;

        if (formData.newpassword !== formData.confirmnewpassword) {
          this.toastr.warning('New password and confirm password do not match!');
          return;
        }
        if (formData.oldpassword === formData.newpassword) {
          this.toastr.warning('Old password and new password should not be the same!');
          return;
        }

        const data = {
          IndustryAssociationUserId: this.IndustryAssociationUserId,
          IAUserName: this.form1.controls.username.value,
          OldPassword: this.form1.controls.oldpassword.value,
          NewPassword: this.form1.controls.newpassword.value,
          ConfirmPassword: this.form1.controls.confirmnewpassword.value
        }

        this.apiService.postRequest(API_ENDPOINTS.IA.CHANGEPASSWORD, data).subscribe((res: { status: any; message: string | undefined; token: string; }) => {

          if (res.status) {
            this.toastr.success(res.message);
            alert("Password updated successully. Please login to verify.")
            this.router.navigate(['/login']);

          }
          else {

            this.toastr.error(res.message);
            this.router.navigate(['/login']);
          }
        })
      }
      else {
        this.form1.markAllAsTouched();
        return;
        //alert('Please fill out the form correctly.');
      }
    }
    else if (this.userType == 'MsMeUser')
    {
      if (this.form1.valid) {
        const formData = this.form1.value;

        if (formData.newpassword !== formData.confirmnewpassword) {
          this.toastr.warning('New password and confirm password do not match!');
          return;
        }
        if (formData.oldpassword === formData.newpassword) {
          this.toastr.warning('Old password and new password should not be the same!');
          return;
        }

        const data = {
          MsMeUserId: this.MsMeUserId,
          MsMeUserName: this.form1.controls.username.value,
          OldPassword: this.form1.controls.oldpassword.value,
          NewPassword: this.form1.controls.newpassword.value,
          ConfirmPassword: this.form1.controls.confirmnewpassword.value,
          Email: this.email,
        }


        this.apiService.postRequest(API_ENDPOINTS.MSME.CHANGEPASSWORD, data).subscribe((res: { status: any; message: string | undefined; token: string; }) => {

          if (res.status) {
            this.toastr.success(res.message);
            alert("Password updated successully. Please login to verify.")
            this.router.navigate(['/login']);

          }
          else {
            this.toastr.error(res.message);
            this.router.navigate(['/login']);
          }
        })
      }
      

      else {
        this.form1.markAllAsTouched();
        return;
        //alert('Please fill out the form correctly.');
      }
    }
    else if (this.userType == 'MSSIDCUser') {
      if (this.form1.valid) {
        const formData = this.form1.value;

        if (formData.newpassword !== formData.confirmnewpassword) {
          this.toastr.warning('New password and confirm password do not match!');
          return;
        }
        if (formData.oldpassword === formData.newpassword) {
          this.toastr.warning('Old password and new password should not be the same!');
          return;
        }

        const data = {
          userMasterUserId: this.MSSIDCUserId,
          userName: this.form1.controls.username.value,
          OldPassword: this.form1.controls.oldpassword.value,
          NewPassword: this.form1.controls.newpassword.value,
          ConfirmPassword: this.form1.controls.confirmnewpassword.value,
          Email: this.email,
        }


        this.apiService.postRequest(API_ENDPOINTS.MSSIDC.CHANGEPASSWORD, data).subscribe((res: { status: any; message: string | undefined; token: string; }) => {

          if (res.status) {
            this.toastr.success(res.message);
            alert("Password updated successully. Please login to verify.")
            this.router.navigate(['/login']);

          }
          else {
            this.toastr.error(res.message);
            this.router.navigate(['/login']);
          }
        })
      }


      else {
        this.form1.markAllAsTouched();
        return;
        //alert('Please fill out the form correctly.');
      }
    }
    else if (this.userType == 'DICUser') {
      if (this.form1.valid) {
        const formData = this.form1.value;

        if (formData.newpassword !== formData.confirmnewpassword) {
          this.toastr.warning('New password and confirm password do not match!');
          return;
        }

        if (formData.oldpassword === formData.newpassword) {
          this.toastr.warning('Old password and new password should not be the same!');
          return;
        }

        const data = {
          userMasterUserId: this.DICUserId,
          userName: this.form1.controls.username.value,
          OldPassword: this.form1.controls.oldpassword.value,
          NewPassword: this.form1.controls.newpassword.value,
          ConfirmPassword: this.form1.controls.confirmnewpassword.value,
          Email: this.email,
        }


        this.apiService.postRequest(API_ENDPOINTS.DIC.CHANGEPASSWORD, data).subscribe((res: { status: any; message: string | undefined; token: string; }) => {

          if (res.status) {
            this.toastr.success(res.message);
            alert("Password updated successully. Please login to verify.")
            this.router.navigate(['/login']);

          }
          else {
            this.toastr.error(res.message);
            this.router.navigate(['/login']);
          }
        })
      }


      else {
        this.form1.markAllAsTouched();
        return;
        //alert('Please fill out the form correctly.');
      }
    }
  }
}
